// Generated by CoffeeScript 2.7.0
var CurrentNamespace, NamespaceAttributes;

import CurrentAttributesFactory from './factory.js';

NamespaceAttributes = ['id', 'name', 'appid', 'logo', 'menu_payload', 'comment_enable', 'enable_elec_signature'];

export default CurrentNamespace = class CurrentNamespace extends CurrentAttributesFactory.fabricate(...NamespaceAttributes) {
  _valueObject() {
    return _global.namespace;
  }

  getVariable(varName) {
    return _global && _global[varName];
  }

};
